/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddAssetsToClickGallery,
    AddAssetsToClickGalleryFromJSON,
    AddAssetsToClickGalleryToJSON,
    ClickBackgroundUploadEndpointRequest,
    ClickBackgroundUploadEndpointRequestFromJSON,
    ClickBackgroundUploadEndpointRequestToJSON,
    ClickGallery,
    ClickGalleryFromJSON,
    ClickGalleryToJSON,
    ClickGalleryLink,
    ClickGalleryLinkFromJSON,
    ClickGalleryLinkToJSON,
    ClickGalleryUpdate,
    ClickGalleryUpdateFromJSON,
    ClickGalleryUpdateToJSON,
    ClickStartUploadEndpointRequest,
    ClickStartUploadEndpointRequestFromJSON,
    ClickStartUploadEndpointRequestToJSON,
    InlineResponse200,
    InlineResponse200FromJSON,
    InlineResponse200ToJSON,
    TaskInfo,
    TaskInfoFromJSON,
    TaskInfoToJSON,
} from '../models';

export interface AbortClickUploadRequest {
    uploadId: string;
}

export interface AddAssetsToClickGalleryRequest {
    connectionId: string;
    id: string;
    addAssetsToClickGallery: AddAssetsToClickGallery;
}

export interface ContinueClickUploadInBackgroundRequest {
    uploadId: string;
    clickBackgroundUploadEndpointRequest: ClickBackgroundUploadEndpointRequest;
}

export interface CreateClickGalleryRequest {
    connectionId: string;
    clickGalleryUpdate: ClickGalleryUpdate;
}

export interface CreateClickGalleryLinkRequest {
    connectionId: string;
    clickGalleryLink: ClickGalleryLink;
}

export interface DeleteClickGalleryLinkRequest {
    connectionId: string;
    id: string;
}

export interface GetAllClickGalleriesRequest {
    connectionId: string;
    ordering?: string;
    limit?: number;
    offset?: number;
}

export interface GetAllClickGalleryLinksRequest {
    connectionId: string;
    ordering?: string;
    limit?: number;
    offset?: number;
}

export interface GetClickGalleryRequest {
    connectionId: string;
    id: string;
}

export interface GetClickGalleryLinkRequest {
    connectionId: string;
    id: string;
}

export interface SendClickGalleryLinkEmailRequest {
    connectionId: string;
    linkId: string;
}

export interface StartClickUploadRequest {
    clickStartUploadEndpointRequest: ClickStartUploadEndpointRequest;
}

/**
 * 
 */
export class ClickApi extends runtime.BaseAPI {

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async abortClickUploadRaw(requestParameters: AbortClickUploadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uploadId === null || requestParameters.uploadId === undefined) {
            throw new runtime.RequiredError('uploadId','Required parameter requestParameters.uploadId was null or undefined when calling abortClickUpload.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/uploads/{upload_id}`.replace(`{${"upload_id"}}`, encodeURIComponent(String(requestParameters.uploadId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async abortClickUpload(requestParameters: AbortClickUploadRequest, initOverrides?: RequestInit): Promise<void> {
        await this.abortClickUploadRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async addAssetsToClickGalleryRaw(requestParameters: AddAssetsToClickGalleryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ClickGallery>> {
        if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
            throw new runtime.RequiredError('connectionId','Required parameter requestParameters.connectionId was null or undefined when calling addAssetsToClickGallery.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling addAssetsToClickGallery.');
        }

        if (requestParameters.addAssetsToClickGallery === null || requestParameters.addAssetsToClickGallery === undefined) {
            throw new runtime.RequiredError('addAssetsToClickGallery','Required parameter requestParameters.addAssetsToClickGallery was null or undefined when calling addAssetsToClickGallery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/connections/{connection_id}/galleries/{id}/add-assets`.replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddAssetsToClickGalleryToJSON(requestParameters.addAssetsToClickGallery),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClickGalleryFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async addAssetsToClickGallery(requestParameters: AddAssetsToClickGalleryRequest, initOverrides?: RequestInit): Promise<ClickGallery> {
        const response = await this.addAssetsToClickGalleryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async continueClickUploadInBackgroundRaw(requestParameters: ContinueClickUploadInBackgroundRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uploadId === null || requestParameters.uploadId === undefined) {
            throw new runtime.RequiredError('uploadId','Required parameter requestParameters.uploadId was null or undefined when calling continueClickUploadInBackground.');
        }

        if (requestParameters.clickBackgroundUploadEndpointRequest === null || requestParameters.clickBackgroundUploadEndpointRequest === undefined) {
            throw new runtime.RequiredError('clickBackgroundUploadEndpointRequest','Required parameter requestParameters.clickBackgroundUploadEndpointRequest was null or undefined when calling continueClickUploadInBackground.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/uploads/{upload_id}/background`.replace(`{${"upload_id"}}`, encodeURIComponent(String(requestParameters.uploadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClickBackgroundUploadEndpointRequestToJSON(requestParameters.clickBackgroundUploadEndpointRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async continueClickUploadInBackground(requestParameters: ContinueClickUploadInBackgroundRequest, initOverrides?: RequestInit): Promise<void> {
        await this.continueClickUploadInBackgroundRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async createClickGalleryRaw(requestParameters: CreateClickGalleryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ClickGallery>> {
        if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
            throw new runtime.RequiredError('connectionId','Required parameter requestParameters.connectionId was null or undefined when calling createClickGallery.');
        }

        if (requestParameters.clickGalleryUpdate === null || requestParameters.clickGalleryUpdate === undefined) {
            throw new runtime.RequiredError('clickGalleryUpdate','Required parameter requestParameters.clickGalleryUpdate was null or undefined when calling createClickGallery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/connections/{connection_id}/galleries`.replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClickGalleryUpdateToJSON(requestParameters.clickGalleryUpdate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClickGalleryFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async createClickGallery(requestParameters: CreateClickGalleryRequest, initOverrides?: RequestInit): Promise<ClickGallery> {
        const response = await this.createClickGalleryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async createClickGalleryLinkRaw(requestParameters: CreateClickGalleryLinkRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ClickGalleryLink>> {
        if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
            throw new runtime.RequiredError('connectionId','Required parameter requestParameters.connectionId was null or undefined when calling createClickGalleryLink.');
        }

        if (requestParameters.clickGalleryLink === null || requestParameters.clickGalleryLink === undefined) {
            throw new runtime.RequiredError('clickGalleryLink','Required parameter requestParameters.clickGalleryLink was null or undefined when calling createClickGalleryLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/connections/{connection_id}/gallery-links`.replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClickGalleryLinkToJSON(requestParameters.clickGalleryLink),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClickGalleryLinkFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async createClickGalleryLink(requestParameters: CreateClickGalleryLinkRequest, initOverrides?: RequestInit): Promise<ClickGalleryLink> {
        const response = await this.createClickGalleryLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async deleteClickGalleryLinkRaw(requestParameters: DeleteClickGalleryLinkRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
            throw new runtime.RequiredError('connectionId','Required parameter requestParameters.connectionId was null or undefined when calling deleteClickGalleryLink.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteClickGalleryLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/connections/{connection_id}/gallery-links/{id}`.replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async deleteClickGalleryLink(requestParameters: DeleteClickGalleryLinkRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteClickGalleryLinkRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async getAllClickGalleriesRaw(requestParameters: GetAllClickGalleriesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ClickGallery>>> {
        if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
            throw new runtime.RequiredError('connectionId','Required parameter requestParameters.connectionId was null or undefined when calling getAllClickGalleries.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/connections/{connection_id}/galleries`.replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClickGalleryFromJSON));
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async getAllClickGalleries(requestParameters: GetAllClickGalleriesRequest, initOverrides?: RequestInit): Promise<Array<ClickGallery>> {
        const response = await this.getAllClickGalleriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async getAllClickGalleryLinksRaw(requestParameters: GetAllClickGalleryLinksRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InlineResponse200>> {
        if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
            throw new runtime.RequiredError('connectionId','Required parameter requestParameters.connectionId was null or undefined when calling getAllClickGalleryLinks.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/connections/{connection_id}/gallery-links`.replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse200FromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async getAllClickGalleryLinks(requestParameters: GetAllClickGalleryLinksRequest, initOverrides?: RequestInit): Promise<InlineResponse200> {
        const response = await this.getAllClickGalleryLinksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async getClickGalleryRaw(requestParameters: GetClickGalleryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ClickGallery>> {
        if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
            throw new runtime.RequiredError('connectionId','Required parameter requestParameters.connectionId was null or undefined when calling getClickGallery.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getClickGallery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/connections/{connection_id}/galleries/{id}`.replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClickGalleryFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async getClickGallery(requestParameters: GetClickGalleryRequest, initOverrides?: RequestInit): Promise<ClickGallery> {
        const response = await this.getClickGalleryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async getClickGalleryLinkRaw(requestParameters: GetClickGalleryLinkRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ClickGalleryLink>> {
        if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
            throw new runtime.RequiredError('connectionId','Required parameter requestParameters.connectionId was null or undefined when calling getClickGalleryLink.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getClickGalleryLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/connections/{connection_id}/gallery-links/{id}`.replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClickGalleryLinkFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async getClickGalleryLink(requestParameters: GetClickGalleryLinkRequest, initOverrides?: RequestInit): Promise<ClickGalleryLink> {
        const response = await this.getClickGalleryLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async sendClickGalleryLinkEmailRaw(requestParameters: SendClickGalleryLinkEmailRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.connectionId === null || requestParameters.connectionId === undefined) {
            throw new runtime.RequiredError('connectionId','Required parameter requestParameters.connectionId was null or undefined when calling sendClickGalleryLinkEmail.');
        }

        if (requestParameters.linkId === null || requestParameters.linkId === undefined) {
            throw new runtime.RequiredError('linkId','Required parameter requestParameters.linkId was null or undefined when calling sendClickGalleryLinkEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/connections/{connection_id}/gallery-links/{link_id}/send`.replace(`{${"connection_id"}}`, encodeURIComponent(String(requestParameters.connectionId))).replace(`{${"link_id"}}`, encodeURIComponent(String(requestParameters.linkId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async sendClickGalleryLinkEmail(requestParameters: SendClickGalleryLinkEmailRequest, initOverrides?: RequestInit): Promise<void> {
        await this.sendClickGalleryLinkEmailRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async startClickUploadRaw(requestParameters: StartClickUploadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<TaskInfo>> {
        if (requestParameters.clickStartUploadEndpointRequest === null || requestParameters.clickStartUploadEndpointRequest === undefined) {
            throw new runtime.RequiredError('clickStartUploadEndpointRequest','Required parameter requestParameters.clickStartUploadEndpointRequest was null or undefined when calling startClickUpload.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/click/uploads`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClickStartUploadEndpointRequestToJSON(requestParameters.clickStartUploadEndpointRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskInfoFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `cloud:access` 
     */
    async startClickUpload(requestParameters: StartClickUploadRequest, initOverrides?: RequestInit): Promise<TaskInfo> {
        const response = await this.startClickUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
